/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import React from 'react';
import DocumentStatusThree from '../../../components/DocumentStatusThree';
import {DownloadProviderImage, GetSingleProviderVehicle} from '../../../reduxToolkit/Providers/providersApi';
import DeleteModal from '../../Modals/DeleteModal';
import UnlinkDeviceChangeModal from '../../Provider/Modal/UnlinkDeviceChangeModal';
import {CreateToExternalVehicle, SetToExternalVehicle,} from '../../../reduxToolkit/Contractor/ContractorApi';
import routes from '../../../Routes/routes';
import HeadTittle from '../../../components/HeadTittle';
import VehicleContractDetailApp from './Functionality/VehicleContractDetailApp';
import DivContainerBody from '../../../components/DivContainerBody';
import {STATUS_MODEL} from '../../../enums/statusEnum';
import {USER_TYPE_DOCUMENT} from '../../../enums/userTypeEnum';
import {TABLES} from '../../../Apis/Tables';
import {EditIcon, TrashOutlineIcon} from '../../../components/buttons/IconButtons';
import ButtonAction from '../../../components/buttons/ButtonAction';
import VehicleDetailsCard from "../Contracts/SubComponents/VehicleDetailsFlows/VehicleDetailsCard";

const VehicalContractDetail = ({ approveDocumentVehicle }) => {

    const {
        t,dispatch,navigate,
        deleteSelectedElement,
        deleteSelectedDocuments,
        selectDocumentsForDelete, setSelectDocumentsForDelete,
        isAllChecked, setIsAllChecked,
        deleteDocShow, setDeleteDocShow,
        unlinkShow, setUnlinkShow,
        deleteVehicleShow, setDeleteVehicleShow,
        selectVehicleForDelete,
        getVehicleDetailById,
        deletedFlag, setDeletedFlag
    } = VehicleContractDetailApp();

    return (
        <>
            <HeadTittle name={getVehicleDetailById?.vehicle?.status?.id === STATUS_MODEL.TO_APPROVE_DOCUMENT  ? t('complete_documents') : t('details')}
                        link={routes.vehicleContractor.search}
            >
                <ButtonAction
                    id='btn_vcd_update'
                    name='update'
                    className='btn-icon-edit'
                    Icon={EditIcon}
                    onClick={()=>{
                        dispatch(GetSingleProviderVehicle(getVehicleDetailById?.vehicle?.id));
                        navigate(`${routes.vehicleContractor.update}${getVehicleDetailById?.vehicle?.id}`)
                    }}
                />
                <ButtonAction
                    id='btn_vcd_delete'
                    name='delete'
                    className='btn-icon-delete'
                    disabled={false}
                    Icon={TrashOutlineIcon}
                    onClick={()=>{
                        setDeleteVehicleShow(true);
                    }}
                />
            </HeadTittle>

            <DivContainerBody>
                <div className='row'>
                    <VehicleDetailsCard elementDetails={getVehicleDetailById}/>

                    <div className='col-8 mb-2'>
                        <div className='w-100 border-card h-100'>
                            <DocumentStatusThree
                                dataTable={getVehicleDetailById?.documents}
                                disabled={false}
                                userType={TABLES.CONTRACTOR_VEHICLE}
                                setDocValue={SetToExternalVehicle}
                                createDocValue={CreateToExternalVehicle}
                                downloadImg={DownloadProviderImage}
                                optionDownload={USER_TYPE_DOCUMENT.CONTRACTOR_VEHICLE_DOCUMENT}
                                isAllChecked={isAllChecked}
                                setIsAllChecked={setIsAllChecked}
                                selectDocumentsForDelete={selectDocumentsForDelete}
                                setSelectDocumentsForDelete={setSelectDocumentsForDelete}

                                showBtnDelete={approveDocumentVehicle} //
                                deleteShowModal={deleteDocShow} //
                                setDeleteShowModal={setDeleteDocShow} //
                                handleDelete={deleteSelectedDocuments} //
                            />
                        </div>
                    </div>
                </div>
            </DivContainerBody>

            {deleteVehicleShow &&
                <DeleteModal
                    title_modal={t('delete_vehicle')}
                    element_modal={t('vehicles')}
                    show={deleteVehicleShow}
                    data={[selectVehicleForDelete]}
                    onHide={() => setDeleteVehicleShow(false)}
                    onClickFn={() => deleteSelectedElement(selectVehicleForDelete)}
                />
            }

            {unlinkShow &&
                <UnlinkDeviceChangeModal
                    show={unlinkShow}
                    onHide={() => setUnlinkShow(false)}
                    onConfirm={() => setDeletedFlag(deletedFlag + 1)}
                />
            }
        </>
    );
};

export default VehicalContractDetail;
